import { $http } from '@/utils/https';
import { objectToQueryString } from '@/helpers/variables';
import type { ActionContext } from 'vuex';
import type { RootState } from '@/store';

interface State {
  pushMessage: any | null;
  isShowPushBlock: boolean;
  isHasPushBlock: boolean | null;
}

const state: State = {
  pushMessage: null,
  isShowPushBlock: false,
  isHasPushBlock: null
};

const getters = {
  pushMessage: (state: State) => state.pushMessage,
  isShowPushBlock: (state: State) => state.isShowPushBlock,
  isHasPushBlock: (state: State) => state.isHasPushBlock
};

const actions = {
  GET_PUSH_MESSAGE: async ({ commit }: ActionContext<State, RootState>) => {
    try {
      const response = await $http.get('v1/pushes');
      commit('SET_PUSH_MESSAGE', response.data);
      return response.data;
    } catch (e) {
      throw e;
    }
  }
};

const mutations = {
  SET_PUSH_MESSAGE(state: State, data: any) {
    let pushMessage = data ? data.data[0] : null;
    state.pushMessage = pushMessage;
    state.isHasPushBlock = !!pushMessage;
  },
  SET_STATUS_PUSH_MESSAGE(state: State, status: boolean) {
    state.isShowPushBlock = status;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
